import { render, staticRenderFns } from "./standardCommonSecondSubFolder.vue?vue&type=template&id=3e56eef0&scoped=true"
import script from "./standardCommonSecondSubFolder.vue?vue&type=script&lang=js"
export * from "./standardCommonSecondSubFolder.vue?vue&type=script&lang=js"
import style0 from "./standardCommonSecondSubFolder.vue?vue&type=style&index=0&id=3e56eef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e56eef0",
  null
  
)

export default component.exports